import type {
  ProfessionalDocumentPendingReason,
  ProfessionalDocumentStatus
} from './professional-documents.types'

/** Elegibilidade por qualificação (medical-docs-qualification) — enums do `00-interfaces.md`. */
export enum QualificationRuleField {
  SEAL = 'SEAL',
  DOCUMENT = 'DOCUMENT'
}

export enum QualificationOnFail {
  BLOCK = 'BLOCK',
  PRE_ALLOCATE = 'PRE_ALLOCATE'
}

export enum QualificationOperator {
  AND = 'AND',
  OR = 'OR'
}

export enum EligibilityResult {
  ELIGIBLE = 'ELIGIBLE',
  PRE_ALLOCATABLE = 'PRE_ALLOCATABLE',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}

export enum PreAllocationStatus {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
  CANCELLED = 'CANCELLED'
}

export enum PreAllocationColumn {
  AWAITING_PROFESSIONAL = 'AWAITING_PROFESSIONAL',
  IN_REVIEW = 'IN_REVIEW',
  RESOLVED = 'RESOLVED'
}

/** Códigos com corpo `{ errorCode, message, missing }` (422). */
export enum QualificationErrorCode {
  QUALIFICATION_NOT_MET = 'QUALIFICATION_NOT_MET',
  QUALIFICATION_PRE_ALLOCATION_REQUIRED = 'QUALIFICATION_PRE_ALLOCATION_REQUIRED',
  HANDOVER_RECEIVER_NOT_QUALIFIED = 'HANDOVER_RECEIVER_NOT_QUALIFIED',
  PRE_ALLOCATION_HAS_PENDING_ITEMS = 'PRE_ALLOCATION_HAS_PENDING_ITEMS'
}

export interface EligibilityReason {
  field: QualificationRuleField
  key: string
  status: ProfessionalDocumentStatus | null
  pendingReason: ProfessionalDocumentPendingReason | null
  onFail: QualificationOnFail
  /**
   * Aditivo (D96): validade (`aaaa-mm-dd`) quando o motivo é `EXPIRED`. Hoje ou depois = o
   * documento ainda vale, mas vence antes do plantão (D91). Backend anterior não manda.
   */
  expiresAt?: string
}

export interface EligibilityOutcome {
  userId: number
  result: EligibilityResult
  reasons: EligibilityReason[]
  policyId: number | null
}

/**
 * Detalhe por item do 422 de lote (tudo-ou-nada, Adendo A3.7). No POST recorrente o
 * plantão ainda não existe: `stationId` vem `null` e a ocorrência é a `stationDate` (A8).
 */
export interface QualificationErrorDetail {
  stationId: number | null
  /** `aaaa-mm-dd` no fuso do plantão. */
  stationDate: string | null
  userId: number
  missing: EligibilityReason[]
}

/** Campo aditivo `preAllocation` por plantão (grade; Adendo A1.2 para `missing`). */
export interface PreAllocationTag {
  status: PreAllocationStatus
  missing: {
    typeKey: string
    name: string
    status: ProfessionalDocumentStatus
    pendingReason: ProfessionalDocumentPendingReason | null
    /** Mesmo campo aditivo de `EligibilityReason.expiresAt` (D96). */
    expiresAt?: string
  }[]
  /** Início do plantão, ISO com o offset do plantão. */
  deadline: string
}

/** Card do Kanban "Demandas urgentes" (`GET /pre-allocations`). */
export interface PreAllocationCard {
  id: number
  column: PreAllocationColumn
  /** `userId` = `User.id` (Adendo A8). */
  professional: { userId: number; name: string; crm: string | null }
  company: { id: number; name: string }
  /** `start` em ISO com o offset do plantão: formatar sem converter para UTC. */
  stations: { doctorStationId: number; start: string; scheduleName: string }[]
  missing: (EligibilityReason & { name: string })[]
  hoursToFirstStation: number
  times: {
    professionalCompletionHours: number | null
    submissionToDecisionHours: number | null
    waitingForOkHours: number
  }
}
